<div class="enrollment-wrapper">
  <div class="heading">
    <h1>
      {{ "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.TOUCHID.TITLE" | translate }}
    </h1>
    <p>
      {{
        "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.TOUCHID.SUB_TITLE" | translate
      }}
    </p>
  </div>

   <!-- will enable the block when there is a track id expired error -->
   <div class="error-block" *ngIf="(page$ | async) === ''">
    <div class="mat-error" *ngIf="(errorState$ | async)?.message">{{ ((errorState$ | async)?.message || "") | translate : {tr_fallback: ((errorState$ | async)?.default_message || "ERROR_OCCURRED") | translate} }}</div>
  </div>

  <!-- screen 1 -->
  <div class="screen-1" *ngIf="(page$ | async) === 'screen1'">
    <div class="qr-code" *ngIf="!(_isMobile() | async)">
      <cid-qr [value]="qrData" [size]="200"></cid-qr>
      <p>
        {{
          "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.SCAN_QR_CODE" | translate
        }}
      </p>
    </div>
    <div class="btn-wrapper">
      <cid-button
        *ngIf="_isMobile() | async"
        [btnOption]="AuthenticatorBtnOptions"
        (clickEvent)="_openAuthenticatorApp()"
      ></cid-button>
    </div>
    <div class="button-group" style="width: 100%">
      <ng-container *ngTemplateOutlet="btnGroupqr"></ng-container>
    </div>
  </div>

  <!-- end of screen 1 -->

  <!-- screen 2 -->
  <div class="screen-2" *ngIf="(page$ | async) === 'screen2' || (appAction$ | async) === 'SCANNED'">
    <div class="screen-2-content">
      <div class="icon">
        <cid-mfa-icon [type]="'touchid'" [status]="(successState$ | async) ? 'success': ((errorState$ | async)?.message) ? 'error' : '' " ></cid-mfa-icon>
      </div>
      <div class="contents">
        <div class="status">
          <div class="success">
            <span *ngIf="(appAction$ | async) === 'ENROLLED'">
              {{
                "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.TOUCHID.SUCCESS"
                  | translate
              }}
            </span>
            <span *ngIf="(appAction$ | async) === 'SCANNED'">
              {{
                "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.TOUCHID.APP_ACTIONS.SCANNED"
                  | translate
              }}
            </span>
          </div>
          <div class="mat-error" *ngIf="(errorState$ | async)?.message">{{ ((errorState$ | async)?.message || "") | translate : {tr_fallback: ((errorState$ | async)?.default_message || "ERROR_OCCURRED") | translate} }}</div>
        </div>
      </div>
    </div>

    <div class="friendlyName" *ngIf="(appAction$ | async) === 'ENROLLED'">
      <cid-friendly-name [enrolledStatus]="successState$ |async" [track_id]="track_id" [method]="'touchid'" (enrolledState)="_completeEnrollmentProcess($event)"></cid-friendly-name>
    </div>
  </div>
  <!-- end of screen 2 -->

  <ng-template #btnGroup>
    <div class="btn-wrapper">
      <div class="btngroup">
        <cid-button
          [btnOption]="cancelBtnOptions"
          (clickEvent)="_cancelEnrollmentProcess()"
        ></cid-button>
        <cid-button
          [btnOption]="continueBtnOptions"

        ></cid-button>
      </div>
    </div>
  </ng-template>

  <ng-template #btnGroupqr>
    <div class="btn-wrapper">
      <div class="btngroup">
        <cid-button
          [btnOption]="cancelBtnOptions"
          (clickEvent)="_cancelEnrollmentProcess()"
        ></cid-button>
      </div>
    </div>
  </ng-template>
</div>
